
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class AnalogNoiseEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(100 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.2 / layerIndex;
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i + Math.floor(time * 30)) - 0.5) * width * 3;
                const ry = (this.pseudoRandom(i + 100 + Math.floor(time * 30)) - 0.5) * height * 3;
                const s = (1 + this.pseudoRandom(i) * 3) * scale;
                ctx.fillRect(rx, ry, s, s);
            }
            
            // Random horizontal lines
            if (this.pseudoRandom(Math.floor(time * 10)) > 0.9) {
                const ly = (this.pseudoRandom(time) - 0.5) * height * 2;
                ctx.fillRect(-width * 2, ly, width * 4, 1 * scale);
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
